import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  divider?: boolean;
  className?: string;
}

const Section = ({ children, divider, className }: Props) => (
  <section className={className}>
    {children}
    {divider && <hr className="tw-mb-32" />}
  </section>
);
export { Section };
